import React from 'react';
import * as Ons from 'react-onsenui';
import Toolbar from '../Toolbar';
import PullHook from '../PullHook';
import Supplementary from './Supplementary';
import { translate as _ } from '../../util/i18n';
import { expired, getRosterPublicStatusIcon, getWeekday } from '../../util';
import { getGameReportRefereeConfig, supports, wording } from '../../util/context';
import { GRR_COMPLETED, GRR_SIGNED_BY_REF, READY_TO_PLAY, ROSTERS_LOCKED, ROSTERS_UNLOCKED } from '../../store/constants/statusCodes';

class Game extends React.Component {

    #pullHookCallback;
    #team;
    #teamId;

    constructor( props ) {

        // console.log( 'components.Pages.Game.constructor()', props );

        super( props );

        this.state = {
            pullHook:          'initial',
            supplementaryOpen: false
        };

        this.handleBackClick              = this.handleBackClick.bind( this );
        this.handleOpenGameReportReferee  = this.handleOpenGameReportReferee.bind( this );
        this.handleOpenRosters            = this.handleOpenRosters.bind( this );
        this.handleOpenSupplementary      = this.handleOpenSupplementary.bind( this );
        this.handlePullHookChange         = this.handlePullHookChange.bind( this );
        this.handlePullHookLoad           = this.handlePullHookLoad.bind( this );
        this.handleSupplementaryBackClick = this.handleSupplementaryBackClick.bind( this );
        this.handleSignSupplementary      = this.handleSignSupplementary.bind( this );
        this.loadGames                    = this.loadGames.bind( this );

        if ( this.props.activeGame ) {

            if ( this.props.activeGame.permission === 'home' ) {

                this.#team   = 'home';
                this.#teamId = this.props.activeGame.homeTeam.id;

            } else if ( this.props.activeGame.permission === 'away' ) {

                this.#team   = 'away';
                this.#teamId = this.props.activeGame.awayTeam.id;

            }

        }

    }

    componentDidMount() {

        expired( this.props.lastUpdate ) && this.loadGames();

    }

    componentDidUpdate() {

        if ( this.#pullHookCallback ) {

            const cb = this.#pullHookCallback;

            setTimeout( () => cb(), 1000 );

            this.#pullHookCallback = null;

        }



    }

    getRosterStatusText() {

        switch ( this.props.activeGame.rosterStatus ) {

            case READY_TO_PLAY:

                return _( 'Ready to Play' );

            case ROSTERS_LOCKED:

                return _( wording( this.props.context, 'lineup' ) ? 'Aufstellungen gesperrt' : 'Roster gesperrt' );

            case ROSTERS_UNLOCKED:

                return _( wording( this.props.context, 'lineup' ) ? 'Aufstellungen offen' : 'Roster offen' );

            default:

                return _( wording( this.props.context, 'lineup' ) ? 'Aufstellungen in Vorbereitung' : 'Roster in Vorbereitung' );

        }

    }

    handleBackClick() {

        this.props.onChangePage( { page: 'games' } );

    }

    handleOpenGameReportReferee() {

        this.props.onChangePage( { page: 'gameReportReferee' } );

    }

    handleOpenRosters() {

        this.props.onChangePage( { page: 'rosters' } );

    }

    handleOpenSupplementary() {

        this.setState( { supplementaryOpen: true } );

    }

    handlePullHookChange( e ) {

        this.setState( { pullHook: e.state } );

    }

    handlePullHookLoad( e ) {

        this.#pullHookCallback = e;

        this.loadGames();

    }

    handleSupplementaryBackClick() {

        this.setState( { supplementaryOpen: false } );

    }

    handleSignSupplementary() {

        this.props.onSignSupplementary( this.props.context, this.props.token, this.props.activeGame.id, this.#team, this.#teamId );

    }

    loadGames() {

        this.props.onLoadGames( this.props.context, this.props.token, this.props.activeSeason.id );

    }

    renderTeamName( team ) {

        return <>{this.props.activeGame[ team + 'Team' ].longName}{getRosterPublicStatusIcon( this.props.context, this.props.activeGame, team )}</>;

    }

    render() {

        // console.log( 'components.Pages.Game.render()', this.props, this.state );

        if ( ! this.props.activeGame ) {

            this.handleBackClick();

            return '';

        }

        const supplementaryAvailable        = ( this.props.activeGame.permission === 'home' && ! this.props.activeGame.supplementaryAcceptedByHomeAt ) || ( this.props.activeGame.permission === 'away' && ! this.props.activeGame.supplementaryAcceptedByAwayAt );
        const gameReportRefereeStatus       = this.props.activeGame.gameReportRefereeStatus ? this.props.activeGame.gameReportRefereeStatus.status : null;
        const enableGameReportRefereeButton = this.props.activeGame.permission === 'referee' || gameReportRefereeStatus === GRR_SIGNED_BY_REF || gameReportRefereeStatus === GRR_COMPLETED;

        return (

            this.state.supplementaryOpen && supplementaryAvailable ?

                <Supplementary
                    gameName={this.props.activeGame.gameName}
                    onBackClick={this.handleSupplementaryBackClick}
                    onMenuClick={this.props.onMenuClick}
                    onSign={this.handleSignSupplementary}
                    loading={this.props.loading}
                />

            :

                <Ons.Page renderToolbar={() => <Toolbar title={_( 'Spiel' )} onBackClick={this.handleBackClick} onMenuClick={this.props.onMenuClick} onReloadClick={this.loadGames} />}>

                    <PullHook onChange={this.handlePullHookChange} onLoad={this.handlePullHookLoad} />

                    {this.props.loading && this.state.pullHook !== 'action' && <Ons.ProgressBar indeterminate className="fixed-progress-bar" />}

                    <h1 className="page-title">{_( 'Spiel' )}</h1>

                    <Ons.Card className="game">

                        <div className="teams">

                            <h3>{this.renderTeamName( 'home' )}</h3>
                            <p>{_( 'vs.' )}</p>
                            <h3>{this.renderTeamName( 'away' )}</h3>

                        </div>

                        <div className="info">

                            <div>
                                <div>{_( 'Spiel' )}</div>
                                <div>{this.props.activeGame.gameName}</div>
                            </div>

                            <div>
                                <div>{_( 'Datum' )}</div>
                                <div>{this.props.activeGame.dateIsToBeDetermined ? _( 'TBD' ) : ( getWeekday( new Date( this.props.activeGame.scheduledDate.sortValue ) ) + ', ' + this.props.activeGame.scheduledDate.shortValue )}</div>
                            </div>

                            <div>
                                <div>{_( 'Uhrzeit' )}</div>
                                <div>{this.props.activeGame.timeIsToBeDetermined ? _( 'TBD' ) : this.props.activeGame.scheduledTime}</div>
                            </div>

                            <div>
                                <div>{_( 'Status' )}</div>
                                <div>{this.getRosterStatusText()}</div>
                            </div>

                            {

                                supports( this.props.context, 'supplementary' ) && this.props.activeGame.permission === 'referee' &&

                                <>

                                    <div className="header">{_( 'Beiblätter' )}</div>

                                    <div>
                                        <div>{_( 'Heim' )}</div>
                                        <div>{this.props.activeGame.supplementaryAcceptedByHomeAt ? new Date( this.props.activeGame.supplementaryAcceptedByHomeAt ).toLocaleString() : '-'}</div>
                                    </div>

                                    <div>
                                        <div>{_( 'Gast' )}</div>
                                        <div>{this.props.activeGame.supplementaryAcceptedByAwayAt ? new Date( this.props.activeGame.supplementaryAcceptedByAwayAt ).toLocaleString() : '-'}</div>
                                    </div>

                                </>

                            }

                        </div>

                        <div className="buttons">

                            <Ons.Button modifier="large" onClick={this.handleOpenRosters}>{this.props.activeGame.permission === 'referee' ? ( wording( this.props.context, 'lineup' ) ? _( 'Aufstellungen' ) : _( 'Roster', 'plural' ) ) : ( wording( this.props.context, 'lineup' ) ? _( 'Aufstellung' ) : _( 'Roster', 'singular' ) )}</Ons.Button>

                            {

                                supports( this.props.context, 'supplementary' ) && (

                                    this.props.activeGame.permission !== 'referee' && (

                                        supplementaryAvailable ?

                                            <>

                                                <Ons.Button modifier="large" onClick={this.handleOpenSupplementary} disabled={! this.props.activeGame.rosterStatus}>{_( 'Beiblatt unterschreiben' )}</Ons.Button>

                                                {! this.props.activeGame.rosterStatus && <p className="note"><Ons.Icon icon="fa-info-circle" /> {_( wording( this.props.context, 'lineup' ) ? 'Beiblatt kann im Status "Aufstellung in Vorbereitung" noch nicht unterschrieben werden.' : 'Beiblatt kann im Status "Roster in Vorbereitung" noch nicht unterschrieben werden.' )}</p>}

                                            </>

                                        :

                                            <div className="alert alert-info">
                                                <p>{_( 'Beiblatt unterschrieben:' )}</p>
                                                <p className="text-center">{new Date( this.props.activeGame.permission === 'home' ? this.props.activeGame.supplementaryAcceptedByHomeAt : this.props.activeGame.supplementaryAcceptedByAwayAt ).toLocaleString()}</p>
                                            </div>

                                    )

                                )

                            }

                            {getGameReportRefereeConfig( this.props.context ) && <Ons.Button modifier="large" onClick={this.handleOpenGameReportReferee} disabled={! enableGameReportRefereeButton}>{_( 'Game Report Referee' )}</Ons.Button>}

                            {

                                this.props.activeGame.permission !== 'referee' && gameReportRefereeStatus !== GRR_SIGNED_BY_REF && gameReportRefereeStatus !== GRR_COMPLETED && (

                                    <p className="note"><Ons.Icon icon="fa-info-circle" /> {_( 'Der Game Report Referee ist verfügbar sobald dieser vom Referee nach dem Spiel freigegeben wurde.' )}</p>

                                )

                            }

                        </div>

                    </Ons.Card>

                </Ons.Page>

        );

    }

}

export default Game;